/*
  One-tap adds for "Complete the set" in the tote, "Pairs well with" and
  "Shop the set" (snippets/mm-cart-pairs.liquid, snippets/mm-set-card.liquid).

  Buttons:
    data-mm-pair-add="VARIANT_ID"          adds one piece
    data-mm-set-add="ID,ID,ID"             adds every piece of a set
    data-mm-set-buy="ID,ID,ID"             adds every piece of a set and goes to checkout (Buy the set now)
    data-mm-pair-source="tote|pdp|set"     recorded on the line as _mm_source

  _mm_source starts with an underscore, so shoppers never see it, but it stays on
  the order line and shows how often suggestions are taken up.

  Words: read from the <script data-mm-i18n> block inside the button's own block each
  time a button is pressed (the tote is re-rendered after every change, so nothing is
  cached). "Complete the set" in the tote carries one (locale keys mm.pairs); blocks
  without one use the English below.
*/
(function () {
  if (window.mmCartPairsReady) return;
  window.mmCartPairsReady = true;

  var FALLBACK = {
    adding: 'Adding',
    error: 'We couldn\'t add that to your tote. Try again.'
  };

  function decode(text) {
    if (text.indexOf('&') === -1) return text;
    var box = document.createElement('textarea');
    box.innerHTML = text;
    return box.value;
  }

  function t(scope, key) {
    var words = {};
    var block = scope && scope.querySelector('[data-mm-i18n]');
    if (block) { try { words = JSON.parse(block.textContent) || {}; } catch (e) { words = {}; } }
    var text = words[key];
    if (typeof text !== 'string' || !text || text.indexOf('translation missing') !== -1) text = FALLBACK[key];
    return decode(text);
  }

  function drawer() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  function add(ids, source, button, toCheckout) {
    var cart = drawer();
    var items = ids.map(function (id) {
      return { id: Number(id), quantity: 1, properties: { _mm_source: source } };
    });
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var box = button.closest('[data-mm-pairs-scope], .mm-pairs, .mm-set');
    var label = button.textContent;
    var adding = t(box, 'adding');
    var failed = t(box, 'error');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = adding;

    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'add failed');
        if (toCheckout) {
          /* Buy now: straight to checkout with the set (and anything already in the tote) */
          window.location.href = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart').replace(/\/cart$/, '/checkout');
          return;
        }
        if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
          window.location.reload();
          return;
        }
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        if (cart) {
          var first = res.json.items && res.json.items[0];
          /* An empty drawer hides its items until this class goes, as the theme's own add button does. */
          cart.classList.remove('is-empty');
          cart.renderContents({ id: first ? first.product_id : null, sections: res.json.sections });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-cart-pairs' });
        }
      })
      .catch(function (err) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
        var msg = box && box.querySelector('[data-mm-pairs-msg]');
        var text = (err && err.message && err.message !== 'add failed')
          ? err.message
          : failed;
        if (msg) msg.textContent = text;
      });
  }

  document.addEventListener('click', function (event) {
    var one = event.target.closest('[data-mm-pair-add]');
    var set = event.target.closest('[data-mm-set-add]');
    var buy = event.target.closest('[data-mm-set-buy]');
    if (!one && !set && !buy) return;
    event.preventDefault();
    var button = one || set || buy;
    if (button.disabled) return;
    var ids = one ? [one.dataset.mmPairAdd] : (set ? set.dataset.mmSetAdd : buy.dataset.mmSetBuy).split(',').filter(Boolean);
    add(ids, button.dataset.mmPairSource || 'pdp', button, !!buy);
  });
})();
